export default __webpack_public_path__ + "static/media/photoVerification.2ea08a8a.jpeg";